import React, { memo, useCallback } from "react";
import {FormBlocks} from './FormBlocks';
import {formFieldsAttributes} from '../../FormBuilderFunctions/FieldProps';

const LongNumber = (props)=>{
  const  {
    item,
    className,
    validationForms,
    fieldObj
  } = props;
  let input_prev_value = null;
  const handleCheck = useCallback((e)=> {
    let input_value = e.target.value.replace(/(\.\%)/,'');  //takes care of '.%' case
    if((input_value.search(/^[0]{1,}[\d]/)!==-1 || // takes care of leading zeroes
        input_value.search(/^(\d+)?[-]?([\d]{1,})?([\%])?$/)===-1) &&  //main pattern
        input_value!==''){
        e.target.value  = (input_prev_value!==undefined)?input_prev_value:'';
        props.onChangeInputAction(fieldObj,e);
    }else {  
        e.target.value = (input_value!==undefined)?input_value:'';
        input_prev_value = e.target.value;
        props.onChangeInputAction(fieldObj,e);
    }
  })

  const attr = formFieldsAttributes(
    {...item,className:className
  },validationForms);
  return (
    <FormBlocks {...props}  attr={attr} >
        <input 
          value={attr.value}
          type="text"
          onChange={e => handleCheck(e)}
          onBlur={e=> props.onBlurHandlerAction(fieldObj,e)}
          {...attr.fieldAttributes}
        />
    </FormBlocks>
  );
}

LongNumber.defaultProps = {
  className: "form-control",
}


const isDiffProps = (prevProps,nextProps)=>{
  if(prevProps.item.selectedValue===nextProps.item.selectedValue && prevProps.validationForms===nextProps.validationForms && prevProps.item.access_mode===nextProps.item.access_mode && prevProps.item.required===nextProps.item.required){
    return true;
  }
}
export default memo(LongNumber,isDiffProps);
